import React from 'react';
interface KPIGaugeProps {
  label: string;
  percentage: number;
  value: string;
  color?: string;
}
export function KPIGauge({
  label,
  percentage,
  value,
  color = '#2563eb'
}: KPIGaugeProps) {
  const radius = 70;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference - percentage / 100 * circumference;
  return <div className="flex flex-col items-center" data-id="element-584">
      <div className="relative w-48 h-48" data-id="element-585">
        <svg className="transform -rotate-90 w-full h-full" data-id="element-586">
          {/* Background circle */}
          <circle cx="96" cy="96" r={radius} stroke="#e5e7eb" strokeWidth="16" fill="none" data-id="element-587" />
          {/* Progress circle */}
          <circle cx="96" cy="96" r={radius} stroke={color} strokeWidth="16" fill="none" strokeDasharray={circumference} strokeDashoffset={strokeDashoffset} strokeLinecap="round" className="transition-all duration-1000 ease-out" data-id="element-588" />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center" data-id="element-589">
          <div className="text-3xl font-bold text-gray-900" data-id="element-590">{percentage}%</div>
          <div className="text-sm text-green-600 bg-green-50 px-2 py-0.5 rounded mt-1" data-id="element-591">
            {value}
          </div>
        </div>
      </div>
      <div className="text-sm text-gray-600 mt-3 text-center font-medium" data-id="element-592">
        {label}
      </div>
    </div>;
}